(function () {
  'use strict';


  angular
    .module('individualCrewExpiryReport', [
      'ui.router'
    ]);
}());
